module.exports = __webpack_public_path__ + "img/bottomLogo.76340248.png";